import { FC } from "react";
import { useThemeStore } from "../../../stores";
import { useResponsive } from "../../../hooks";

const NavbarPlaceholder: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const isMobile = useResponsive();

  return (
    <div
      style={{
        minWidth: !isMobile ? 96 : 0,
        width: !isMobile ? "auto" : 0,
        height: "100%",
        background: theme.overlay,
      }}
    ></div>
  );
};

export default NavbarPlaceholder;
